module.exports = __webpack_public_path__ + "static/media/gensuite-csr.c158ddb7.png";